"use client";

import React from "react";
export default function VideoGallery() {
  return <section id="video-gallery" className="w-full py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-[900px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
          <div data-index="0" className="w-full">
            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/w19Xt04YtZI" title="Video 1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="rounded-lg shadow-md"></iframe>
          </div>
          <div data-index="1" className="w-full">
            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/1ljJ_qqj3P4" title="Video 2" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="rounded-lg shadow-md"></iframe>
          </div>
        </div>
      </div>
    </section>;
}